// extracted by mini-css-extract-plugin
module.exports =  {"largeIllustration":"SpotDefault-module__largeIllustration____1LJb"};